require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-medbridge-wins-geekwires-bootstrapper-of-year.json") })
        }
      }, "path---blog-medbridge-wins-geekwires-bootstrapper-of-year");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-medbridge-wins-geekwires-bootstrapper-of-year!./.cache/json/blog-medbridge-wins-geekwires-bootstrapper-of-year.json
// module id = 933
// module chunks = 231608221292675